module.exports = __webpack_public_path__ + "img/1726037237490-screenshot-1726037181196.png.fff8c20f.webp";